import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useBackground } from './composables/useBackground'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { backgroundTheme } = useBackground()
const bgTheme = computed(() => `bg-${backgroundTheme.value}`)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg dark", bgTheme.value])
  }, [
    _createVNode(_component_router_view)
  ], 2))
}
}

})